(function(){
    'use strict';


    var bigSlider = $('.big-slider_list');

    bigSlider.on('init', function(event, slick){

        var video = $(slick.$slides[0]).find('.mainbanner_video');
        if (video.length) {
            video[0].play();
        }

    });
    

    bigSlider.on('afterChange', function(event, slick, currentSlide){

        var video = $(slick.$slides[currentSlide]).find('#player');
        if (video.length) {
            video[0].play();
        }

    });

    bigSlider.slick({

    });
    

})();